export default __webpack_public_path__ + "static/media/manageFilled.6cc1ee59.svg";